<template>
  <a-card class="m-height-full m-display-flex flex-column nowrap m-coming-soon">
    <img src="@/assets/coming-soon.png" alt />
    <span>
      Our Dashboard is
      <b>Coming soon</b>
    </span>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "beranda",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getScreen"]),
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
};
</script>

<style></style>
